import { Component, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Calibration_Interface, Empty_Calibration_Interface } from 'src/app/Interface/Calibration_Interface';
import { FeildActivity_Interface } from 'src/app/Interface/FeildActivity_Interface';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { CalibrationService } from 'src/app/Service/Calibration/Calibration.service';
import { ExpirationService } from 'src/app/Service/Expiration/Expiration.service';

@Component({
  selector: 'app-DataEntityDeviceInfo',
  templateUrl: './DataEntityDeviceInfo.component.html',
  styleUrls: ['./DataEntityDeviceInfo.component.scss']
})
export class DataEntityDeviceInfoComponent implements OnInit {

  Calibration_Device: Calibration_Interface = Empty_Calibration_Interface();
  Token: String = ''

  @Input() inner_calibration_id: number = 0
  @Output() outter_Calibration_Device = new EventEmitter<Calibration_Interface>();

  constructor(
    private Calibration_Service: CalibrationService,
    private Expiration_Service: ExpirationService,
    private Alertify_Service: AlertifyService,
    private modalService: BsModalService
  ) { }

  ngOnInit() {
    this.Token = localStorage.getItem('Daro_User_Token');
    this.Read_Calibration()
  }


  Read_Calibration() {
    this.InProccessing = true
    this.Calibration_Service.GetSingleCalibrationDetail(
      this.Token,
      this.inner_calibration_id
    ).subscribe(
      (data) => {
        this.Calibration_Device = data;
        this.outter_Calibration_Device.emit(this.Calibration_Device);
        this.Read_Expiration()
      },
      (error) => {
        localStorage.clear();
        location.reload();
      }
    );
  }


  Datalist_Expiration: Array<FeildActivity_Interface> = []
  Read_Expiration() {
    this.Expiration_Service.GetActiveAndId(this.Token, this.Calibration_Device.expiration).subscribe(
      (data) => {
        this.Read_RelativeDeviceName()
        this.Datalist_Expiration = data;
        this.InProccessing = false
      },
      (error) => {
        localStorage.clear();
        location.reload();
      }
    );
  }


  InProccessing: boolean = false
  SubmitCalibration() {
    this.InProccessing = true
    this.Calibration_Service.SubmitCalibrationCertification(
      this.Token,
      this.inner_calibration_id,
      this.Calibration_Device.priod,
      this.Calibration_Device.expert_off,
      this.Calibration_Device.device_code,
      this.Calibration_Device.device_serial,
      this.Calibration_Device.expiration).subscribe(
        data => {
          this.InProccessing = false
          this.Alertify_Service.SuccessMessage("The information was saved successfully.")
          this.outter_Calibration_Device.emit(this.Calibration_Device)
        },
        (error) => {
          localStorage.clear();
          location.reload();
        }
      )
  }

  //#region RelativeDeviceName
  Dsc_RelativeDevice:string=''
  DataList_RelativeDevice: Array<General_Interface> = []
  Read_RelativeDeviceName() {
    this.Calibration_Service.GetCalibrationRelativeDeviceName(this.Token, this.inner_calibration_id).subscribe(
      (data) => {
        this.DataList_RelativeDevice = data;
        this.InProccessing = false
      },
      (error) => {
        localStorage.clear();
        location.reload();
      }
    );
  }
  modalRef_RelativeDeviceName: any
  openModal(template: TemplateRef<any>) {
    this.Dsc_RelativeDevice=""
    this.modalRef_RelativeDeviceName = this.modalService.show(template);
  }

  SubmitCalibrationCertificationDevicename(item:General_Interface)
  {
    if(!this.Dsc_RelativeDevice)
    {
      this.Alertify_Service.ErrorMessage("Enter the request description.")
    }
    else{
    this.modalRef_RelativeDeviceName.hide()
    this.Calibration_Service.SubmitCalibrationCertificationDevicename(this.Token,
      this.inner_calibration_id,
      item.title+'',
      this.Dsc_RelativeDevice).subscribe(
        data=>{
          if(data['id']==-1)
            this.Alertify_Service.ErrorMessage("An active name change request already exists.")
          else if (data['id'] == -2) {
            this.Alertify_Service.ErrorMessage("No active workflow has been selected for the instrument name change request.")
          }
          else if (data['id'] == -3) {
            this.Alertify_Service.ErrorMessage("System error.")
          }
          else if (data['id'] == -4) {
            this.Alertify_Service.ErrorMessage("You have no assigned position in the organizational chart.")
          }
          else
            this.Alertify_Service.SuccessMessage("The information was saved successfully.")
        }
      )
    }
  }


  //#endregion

}
